/**
 * @generated SignedSource<<201662059b5c7535b57239beb1421306>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UploadModal_getUploadUrlMutation$variables = {
  fileExtension: string;
};
export type UploadModal_getUploadUrlMutation$data = {
  readonly getMeetingRecordingUploadUrl: {
    readonly fields: any;
    readonly uploadUrl: string;
  } | null;
};
export type UploadModal_getUploadUrlMutation = {
  response: UploadModal_getUploadUrlMutation$data;
  variables: UploadModal_getUploadUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fileExtension",
        "variableName": "fileExtension"
      }
    ],
    "concreteType": "GetMeetingRecordingUploadUrl",
    "kind": "LinkedField",
    "name": "getMeetingRecordingUploadUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fields",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadModal_getUploadUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadModal_getUploadUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "221914a08aa3d7ec16456293f7ec5b3a",
    "id": null,
    "metadata": {},
    "name": "UploadModal_getUploadUrlMutation",
    "operationKind": "mutation",
    "text": "mutation UploadModal_getUploadUrlMutation(\n  $fileExtension: String!\n) {\n  getMeetingRecordingUploadUrl(fileExtension: $fileExtension) {\n    uploadUrl\n    fields\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f7d09baa7baba42d974017b02b324b1";

export default node;
